import { categories } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center pt-20 pb-16 px-6 md:px-10">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20desk%20setup%20with%20open%20notebook%20and%20tablet%20displaying%20colorful%20organized%20product%20grid%2C%20gentle%20morning%20sunlight%20casting%20soft%20shadows%20across%20cream%20surface%2C%20ceramic%20coffee%20cup%20with%20steam%2C%20small%20succulent%20plant%20in%20terracotta%20pot%2C%20calm%20productive%20atmosphere%2C%20editorial%20product%20photography%20with%20warm%20neutral%20palette%2C%20no%20text%20no%20people%2C%20clean%20aesthetic%20composition&width=1600&height=900&seq=hero-bg-superbuy-v2&orientation=landscape"
          alt="Superbuy Spreadsheet organized product discovery workspace"
          title="Superbuy Spreadsheet - Product Discovery Resource"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/30 to-background-50/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-accent-100/80 rounded-full mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-semibold text-accent-700 uppercase tracking-wider">Updated 2026 Database</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl leading-tight text-foreground-950 mb-5">
              Superbuy Spreadsheet
              <br />
              <span className="text-primary-500">Find The Best Products Faster</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 max-w-lg mx-auto lg:mx-0 mb-8 leading-relaxed">
              Access the most organized Superbuy Spreadsheet database featuring trending products, 
              verified finds, and detailed shopping guides — all in one place. 
              Save hours of searching and discover hidden gems across every category.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all text-base whitespace-nowrap cursor-pointer"
              >
                Superbuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 font-semibold rounded-full hover:bg-foreground-800 transition-all text-base whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-shopping-bag-line"></i>
              </a>
              <button
                onClick={() => navigate('/blog/superbuy-spreadsheet-guide')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-full hover:border-primary-500 hover:text-primary-500 transition-all text-base whitespace-nowrap cursor-pointer"
              >
                Read Guide
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>

            <div className="flex flex-wrap items-center gap-5 mt-8 justify-center lg:justify-start">
              {['Updated Product Database', 'Category Organized', 'Beginner Friendly', 'Shopping Safety Tips'].map((badge) => (
                <span key={badge} className="flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                  {badge}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-xl">
            <div className="relative bg-background-50 rounded-3xl p-3 shadow-sm border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20UI%20dashboard%20mockup%20displayed%20on%20a%20floating%20tablet%20screen%20with%20organized%20data%20table%20rows%20showing%20product%20thumbnails%20category%20labels%20price%20tags%20and%20status%20indicators%2C%20soft%20shadow%20on%20warm%20cream%20background%2C%20minimal%20design%20aesthetic%2C%20professional%20app%20interface%2C%20no%20real%20text%20just%20placeholder%20blocks%2C%20editorial%20product%20shot&width=800&height=600&seq=hero-dashboard-preview-v2&orientation=landscape"
                alt="Superbuy Spreadsheet product database preview"
                title="Superbuy Spreadsheet Database Interface"
                className="w-full h-auto rounded-2xl"
                style={{ width: '100%', height: 'auto' }}
              />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 bg-accent-100 rounded-2xl flex items-center justify-center">
                <i className="ri-database-2-line text-2xl text-accent-600"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}